import request from '@/utils/request'

const purchase = {
  // 采购的业务类型
  selectAllBusinessTypePurchase(query) {
    return request({
      url: '/scrm/businesstype/selectAllBusinessTypePurchase',
      method: 'get',
      params: query
    })
  },
  // 查询采购合同管理列表
  listSaleContract(query) {
    return request({
      url: '/cont/newSaleContract/list',
      method: 'get',
      params: query
    })
  },
  // 获取采购合同管理详细信息
  getSaleContract(contractId) {
    return request({
      url: '/cont/newSaleContract/' + contractId,
      method: 'get'
    })
  },
  // 新增采购合同管理
  addSaleContract(data) {
    return request({
      url: '/cont/newSaleContract',
      method: 'post',
      data: data
    })
  },
  // 修改采购合同管理
  updateSaleContract(data) {
    return request({
      url: '/cont/newSaleContract',
      method: 'put',
      data: data
    })
  },
  // 删除采购合同管理
  deleteSaleContract(contractId) {
    return request({
      url: '/cont/newSaleContract/' + contractId,
      method: 'delete'
    })
  },

  // 修改合同跟进人
  batchInherit(data) {
    return request({
      url: '/cont/newSaleContract/batchInherit',
      method: 'post',
      data: data
    })
  },
  // 跟进人批量共享合同信息
  batchShareContract(data) {
    return request({
      url: '/cont/newSaleContract/batchShareContract',
      method: 'post',
      data: data
    })
  },
  // 管理员修改采购合同管理
  editAdmin(data) {
    return request({
      url: '/cont/newSaleContract/editAdmin',
      method: 'post',
      data: data
    })
  },
  // 业务员修改采购合同管理
  editBuss(data) {
    return request({
      url: '/cont/newSaleContract/editBuss',
      method: 'post',
      data: data
    })
  },
  // 合同信息导出
  exportContractList(query) {
    return request({
      url: '/cont/newSaleContract/exportContractList',
      method: 'get',
      params: query
    })
  },
  // 查询合同数量[草稿：cgCount|用章：yzCount|垫款：dkCount|驳回：bhCount|用印：yyCount|签署：qs|归档：gdCount|借阅：jyCount|作废：zfCount]
  getContCount(query) {
    return request({
      url: '/cont/newSaleContract/getContCount',
      method: 'get',
      params: query
    })
  },
  // 得到可用编号数量
  getContractNumCount(data) {
    return request({
      url: '/cont/newSaleContract/getContractNumCount',
      method: 'post',
      data: data
    })
  },
  // 打款充值-查询采购合同管理列表
  listPayment(query) {
    return request({
      url: '/cont/newSaleContract/listPayment',
      method: 'get',
      params: query
    })
  },
  // 签署归档
  placeFile(data) {
    return request({
      url: '/cont/newSaleContract/placeFile',
      method: 'post',
      data: data
    })
  },
  // 用章审批申请
  spApply(data) {
    return request({
      url: '/cont/newSaleContract/spApply',
      method: 'post',
      data: data
    })
  },
  // 上传审批附件
  upload(data) {
    return request({
      url: '/cont/newSaleContract/upload',
      method: 'post',
      data: data
    })
  },

  // 查询采购合同付款约定列表
  listSaleAgree(query) {
    return request({
      url: '/cont/saleAgree/list',
      method: 'get',
      params: query
    })
  },
  // 获取采购合同付款约定详细信息
  getSaleAgree(salePayAgreeId) {
    return request({
      url: '/cont/saleAgree/' + salePayAgreeId,
      method: 'get'
    })
  },
  // 新增采购合同付款约定
  addSaleAgree(data) {
    return request({
      url: '/cont/saleAgree',
      method: 'post',
      data: data
    })
  },
  // 修改采购合同付款约定
  updateSaleAgree(data) {
    return request({
      url: '/cont/saleAgree',
      method: 'put',
      data: data
    })
  },
  // 删除采购合同付款约定
  deleteSaleAgree(salePayAgreeId) {
    return request({
      url: '/cont/saleAgree/' + salePayAgreeId,
      method: 'delete'
    })
  },

  // 查询销售合同执行客户列表   获取项目名称
  getSaleContractCustName(data) {
    return request({
      url: '/cont/newSaleContract/getSaleContractCustName',
      method: 'post',
      data: data
    })
  }
}

export default purchase
